import React from 'react'
import c from 'classnames'

import Button from 'discada/dist/Button'

import './Collection.scss'

export function CollectionItem({
  item = {},
  items = [],
  itemRenderer = () => {},
  className,
  removeItem = () => {},
  itemIndex,
  hideRemove,
}) {
  return (
    <div className={c('collection-item', className, item.className)}>
      <div className="collection-item-content">
        {itemRenderer(item, itemIndex, items)}
      </div>
      <div className="collection-item-controls">
        {!hideRemove && (
          <Button
            size="small"
            icon="times"
            onClick={() => removeItem(itemIndex, items)}
          />
        )}
      </div>
    </div>
  )
}

export default function Collection(props) {
  let {
    label,
    className,
    addButtonLabel,
    headers = [],
    items = [],
    addItem,
    renderControls = true,
  } = props

  return (
    <div className={c('collection', className)}>
      {label && <h3 className="collection-title">{label}</h3>}

      {items.length > 0 && (
        <div className="collection-field-headers">
          {headers.map((h, i) => (
            <span key={i}>{h}</span>
          ))}
          <span className="remove-placeholder" />
        </div>
      )}

      {items.map((item, i) => (
        <CollectionItem {...props} key={i} item={item} itemIndex={i} />
      ))}

      {renderControls ? (
        <div className="collection-controls">
          <Button size="small" icon="plus" onClick={addItem}>
              {addButtonLabel || 'Add'}
          </Button>
        </div>
      ) : ([])}
    </div>
  )
}
